import moment from 'moment';

import type { TimeFormat } from '@app/api/Branches/types';

export interface TimeObject {
  id: string;
  '24-hours': string;
  '12-hours': string;
}

export const generateTimes = (
  startTime: string = '00:00',
  endTime: string = '23:59',
  interval: number = 15,
  timeFormat: TimeFormat = '24-hours'
): string[] => {
  const start = moment(startTime, 'HH:mm');
  const end = moment(endTime, 'HH:mm');
  const times: string[] = [];
  const formatStr = timeFormat === '12-hours' ? 'hh:mm' : 'HH:mm';

  while (start <= end) {
    times.push(start.format(formatStr));
    start.add(interval, 'minutes');
  }

  return times;
};

export const generateTimesObj = (
  startTime: string = '00:00',
  endTime: string = '23:59',
  interval: number = 15
): TimeObject[] => {
  const timeSlots: TimeObject[] = [];

  const start = moment(startTime, 'HH:mm');
  const end = moment(endTime, 'HH:mm');

  const currentTime = start.clone();

  while (currentTime.isSameOrBefore(end)) {
    const time24 = currentTime.format('HH:mm');
    const hours = currentTime.hours();
    const twelveHour =
      hours % 12 === 0 ? '00' : (hours % 12).toString().padStart(2, '0');
    const time12 = `${twelveHour}:${currentTime.format('mm')}`;

    timeSlots.push({
      id: time24,
      '24-hours': time24,
      '12-hours': time12,
    });

    currentTime.add(interval, 'minutes');
  }

  return timeSlots;
};
